import { Page } from 'Common/Page/Page'
import { Box } from '@mui/material'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { Button, PageHeader } from 'Common/Supplyvue-ui'
import { useInventoryResults } from 'Features/Projects/Scenarios/Inventory/Inventory.data'
import { useParams } from 'react-router-dom'
import { Loader } from 'Common/Loader/Loader'
import { ErrorDisplay } from 'Common/Error/Error'
import { InventoryResultsTable } from 'Features/Projects/Scenarios/Inventory/Inventory.results.table'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

export const InventoryResultsView = () => {
  const { view_width } = useWindowSize()
  const { projectId, scenarioId } = useParams<{
    projectId: string
    scenarioId: string
  }>() as { projectId: string; scenarioId: string }

  const { data, isLoading, isError, isRefetching, refetch } =
    useInventoryResults({
      projectId,
      scenarioId,
    })

  const Return = () => {
    return (
      <Box display="flex">
        <Button
          variant="text"
          sx={{ fontWeight: 600 }}
          startIcon={<ArrowBackIcon />}
          onClick={() => window.history.back()}
        >
          Back
        </Button>
      </Box>
    )
  }

  return (
    <Page>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'flex-start',
          maxWidth: view_width,
        }}
      >
        <PageHeader title="Inventory Results" rightElement={<Return />} />
        {isLoading && <Loader />}
        {isError && <ErrorDisplay />}
        {data && (
          <InventoryResultsTable
            data={data}
            isRefetching={isRefetching}
            handleRefetch={() => refetch()}
          />
        )}
      </Box>
    </Page>
  )
}
